// extracted by mini-css-extract-plugin
export default {"textStyleContainer":"firstScreen_textStyleContainer__RZxIk"};